import toyotaLogo from '../../../assets/toyota_logo.png';
import raymondLogo from '../../../assets/raymond_logo.png';

export const manufacturerConfig = {
  toyota: {
    name: 'Toyota',
    title: 'Telemetric Dashboard',
    description: 'This dashboard provides comprehensive telemetric data and analytics for Toyota operations.',
    color: '#e87b19', // Toyota orange
    logo: toyotaLogo
  },
  'raymond-us': {
    name: 'Raymond US',
    title: 'Telemetric Dashboard', 
    description: 'This dashboard provides comprehensive telemetric data and analytics for Raymond US operations.',
    color: '#cf202e', // Raymond red
    logo: raymondLogo
  },
  'raymond-eu': {
    name: 'Raymond EU',
    title: 'Telemetric Dashboard', 
    description: 'This dashboard provides comprehensive telemetric data and analytics for Raymond EU operations.',
    color: '#cf202e', // Raymond red
    logo: raymondLogo
  }
};
